import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Before School' },
    { value: 2, label: 'Morning' },
    { value: 3, label: 'Lunch Time' },
    { value: 4, label: 'After Lunch Time' },
    { value: 5, label: 'Afternoon' },
    { value: 6, label: 'Recess' },
    { value: 7, label: 'Other' },
  ],
});
